import type { RefObject } from 'react';
import { useState } from 'react';
import type { StripeCardNumberElement } from '@stripe/stripe-js';
import type braintree from 'braintree-web';
import type { AdyenCardComponent } from '@/types/adyen';
import type { SafeChargeFields } from '@/types/nuvei';
import type { AppchargePaymentElementCard } from '@/types/appchargePaymentElement';

export const useCardElementRef = () => {
  const [cardElementRef, setCardElementRef] = useState<RefObject<
    | StripeCardNumberElement
    | braintree.HostedFields
    | AdyenCardComponent
    | SafeChargeFields
    | AppchargePaymentElementCard
    | null
  > | null>(null);

  return {
    cardElementRef,
    setCardElementRef,
  };
};
